var r,n;function u(){return n?r:(n=1,r=function(r){return null==r})}export{u as __require};
//# sourceMappingURL=is-null-or-undefined.js.map
